import { flex, flexColumn } from 'hfty-styles/src/mixins'
import { primary, white, black } from 'hfty-styles/src/colors'

const TABLE_CELL = {
  height: '55px',
  textAlign: 'left',
  borderTop: `1px solid ${primary()}`,
  borderBottom: `1px solid ${primary()}`,
}

export const styles = {
  tableWrapper: {
    width: '100%',
  },

  table: {
    width: '75%',
    borderSpacing: '0.5rem',
    borderCollapse: 'collapse',
  },
  tableHeadCell: {
    width: '100px',
    ...TABLE_CELL,
  },
  tableHeadCellCheckbox: {
    width: '40px',
    ...TABLE_CELL,
  },
  tableHeadCellField: {
    minWidth: '200px',
    ...TABLE_CELL,
  },

  tableBodyRow: {
    height: '40px',
  },
  totalRow: {
    height: 40,
    borderTop: '1px solid lightgray',
  },
  footer: {
    ...flexColumn('flex-start', 'flex-end'),
    width: '75%',
    marginTop: '50px',
    paddingTop: '15px',
    borderTop: `3px solid ${black()}`,
  },

  submitButton: {
    width: '160px',
    height: '45px',
    fontSize: '17px',
    color: white(),
    backgroundColor: primary(),
    border: `1px solid ${primary()}`,
    cursor: 'pointer',
  },

  footerDescription: {
    display: 'block',
    marginBottom: '15px',
    fontSize: '18px',
  },

  minimumCharge: {
    ...flex('flex-start'),
    width: '100%',
    fontSize: '18px',
    color: '#5975B9',
  },
  success: {
    height: 30,
    fontSize: '12px',
    backgroundColor: primary(0.6),
    borderColor: primary(),
    borderWidth: '1px',
    lineHeight: '22px',
    paddingTop: 10,
    width: '75%',
    paddingLeft: 5,
  },
}
